<mat-form-field [formGroup]="formGroup" class="filter-field" color="primary" appearance="outline">
  <input matInput type="text" [formControlName]="filterName">
</mat-form-field>
